import React from 'react';
import { isAiInput, SourceType } from '@/modules/surgicalEvent';
import MemoryIcon from '@mui/icons-material/Memory';
import { SourceTypeTooltip } from './SourceTypeTooltip';

export const AiBadge = ({
  sourceType,
  justification
}: {
  sourceType?: SourceType;
  justification?: string;
}) => {
  if (!isAiInput(sourceType)) {
    return null;
  }

  return (
    <div className="source-type-icon ai">
      <SourceTypeTooltip sourceType={sourceType} justification={justification}>
        <MemoryIcon />
      </SourceTypeTooltip>
    </div>
  );
};
